var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMedia = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 19,
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_10288_8828)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.48633 14.4999C6.31633 14.4999 6.13633 14.4599 5.98633 14.3599C5.67633 14.1799 5.48633 13.8499 5.48633 13.4999V5.49988C5.48633 5.13988 5.67633 4.80988 5.98633 4.63988C6.29633 4.45988 6.67633 4.45988 6.98633 4.63988L13.9863 8.63988C14.2963 8.81988 14.4863 9.14988 14.4863 9.50988C14.4863 9.86988 14.2963 10.1999 13.9863 10.3799L6.98633 14.3799C6.83633 14.4699 6.66633 14.5099 6.48633 14.5099V14.4999ZM7.48633 7.21988V11.7699L11.4663 9.48988L7.48633 7.20988V7.21988Z",
  fill: "#97E3FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.4863 18.5H3.48633C1.83633 18.5 0.486328 17.15 0.486328 15.5V3.5C0.486328 1.85 1.83633 0.5 3.48633 0.5H15.4863C17.1363 0.5 18.4863 1.85 18.4863 3.5V15.5C18.4863 17.15 17.1363 18.5 15.4863 18.5ZM3.48633 2.5C2.93633 2.5 2.48633 2.95 2.48633 3.5V15.5C2.48633 16.05 2.93633 16.5 3.48633 16.5H15.4863C16.0363 16.5 16.4863 16.05 16.4863 15.5V3.5C16.4863 2.95 16.0363 2.5 15.4863 2.5H3.48633Z",
  fill: "#97E3FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_10288_8828"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white",
  transform: "translate(0.486328 0.5)"
})))));
export default SvgIconMedia;